<div class="topbar">

    <div class="left">
        <img class="logo" src="/images/logo.png" alt="Fun Box">
    </div>
    <div class="center">
        <img class="game-name" src="/images/game-name.png" alt="Bin Fun">
    </div>
    <div class="right">
        <slot />
    </div>

</div>

<style lang="scss">

    $height: 80px;

    .topbar {
        width: 100%;
        display: flex;
        height: $height;
        border-bottom: 2px solid #fff;
    }

    .left, .right {
        width: $height;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .center {
        flex: 1 1 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .logo {
        width: $height * 0.75;
        height: $height * 0.75;
        object-fit: contain;
    }

    .game-name {
        height: $height * 0.75;
        width: calc(100% - 16px);
        max-width: 250px;
        object-fit: contain;
    }

</style>
